import React, {useEffect, useMemo} from 'react';
import {normalizeGamePush} from '@/utils/game';
import {useHomeStore} from '../store';
import useInfiniteList from '@/hooks/useInfiniteList';
import {getGamePicUrl, GamePicType} from '@/components/utils';
import {goTo} from '@/utils';
import {useTranslation} from 'react-i18next';

export default function Casino() {
  const {fetchCasinoGames, selectedProvider, selectedGameType} = useHomeStore();
  const {i18n} = useTranslation();

  const fetchData = useMemo(() => {
    return ({page, pageSize}: {page: number; pageSize: number}) => {
      console.log('fetchdata', page);
      return fetchCasinoGames({page, pageSize});
    };
  }, [fetchCasinoGames]);

  const {
    items: casinoGames,
    refresh,
    reset,
  } = useInfiniteList({
    fetchData,
    pageSize: 18,
  });

  // 当provider或gameType改变时重置数据
  useEffect(() => {
    reset();
    refresh();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedProvider, selectedGameType]);

  return (
    <div>
      <div className="grid grid-cols-3 gap-2 px-3">
        {casinoGames.map(game => (
          <div
            key={game.id}
            className="aspect-square"
            onClick={() => normalizeGamePush(game.id, true)}>
            <img
              src={getGamePicUrl(
                GamePicType.V_RECTANGLE,
                game.source,
                game.tripartiteUniqueness,
              )}
              alt={game.name}
              className="w-full aspect-[375/520] object-cover rounded-lg"
            />
          </div>
        ))}
      </div>
      <div className="px-3 py-3 flex justify-center">
        <div
          className="rounded-lg bg-primary text-t1 font-bold bg-white w-[10rem] h-10 flex items-center justify-center cursor-pointer"
          onClick={() => {
            const targetPage = selectedGameType === 'LIVE' ? 'Live' : 'Casino';
            goTo(
              targetPage,
              selectedProvider === '0' ? {} : {provider: selectedProvider},
            );
          }}>
          {i18n.t('home.label.showMore')}
        </div>
      </div>
    </div>
  );
}
